import React, { FC, use, useEffect, useMemo, useState } from "react";
import { PageFullScreen } from "../components/shared/appearance/page";
import { useParams, useSearchParams } from "react-router-dom";
import { RecordFormFileUploader } from "@app/components/recordform/FileUploader/RecordFormFileUploader";
import { RecordsContext } from "../../scripts/context/accountingData/RecordsCtx";

export const ViewerView: FC = () => {
    const params = useParams<{ channelId: string }>();
    const [searchParams] = useSearchParams();
    const [recordId, setRecordId] = useState(searchParams.get("initialRecordId"));
    const { allRecords } = use(RecordsContext);

    useEffect(() => {
        const bc = new BroadcastChannel(params.channelId);
        bc.onmessage = event => {
            setRecordId(event.data.recordId);
        };
        return () => {
            bc.close();
        };
    }, [params.channelId]);

    const record = useMemo(() => allRecords.map.get(recordId), [allRecords.map, recordId]);
    const documentIds = useMemo(() => (record?.documents ?? []).map(v => v.id), [record]);
    return (
        <PageFullScreen style={{ paddingLeft: 25, paddingRight: 25, paddingTop: 10, paddingBottom: 5 }}>
            <h3>Viewer</h3>
            <RecordFormFileUploader
                mode="table"
                useExternalState
                currentDocumentIds={documentIds}
                onHide={() => {}}
                onSave={() => {}}
                allowEdit={false}
                // allowEdit={!record.journaled && !record.cancellation}
                // onSave={this.onDocumentsViewerChange(documentModalRecord)}
                productKey={record?.getProductKey()}
            />
        </PageFullScreen>
    );
};
